<template>
  <div
    :class="[
      'swatches-view-swatches-wrapper-swatches',
      subgroup.name + '-container',
      {
        center : isContainerCenter,
        'swatches-view-swatches-wrapper-swatches--first-subgroup': isFirstSubgroup,
      }
    ]"
    v-show="isSubgroupHidden"
  >
    <div v-show="!hasNoSubgroups" :class="['subgroup-title', subgroup.name + '-group']">
      <span class="price">{{ getUpchargeDisplay(groupName, subgroup.name)}}</span>
      <v-popover
        v-if="ugcBlockedPalette || subgroup.tooltip_text"
        :delay="{'show':500}"
        class="swatches-view-swatches-wrapper-swatches-ugc-block"
        :popoverClass="['swatches-view-v-popover ',
          {'ugc-block' : ugcBlockedPalette,
          'stitching-message' : subgroup.tooltip_text},
        ]"
        placement="top"
        trigger="hover click"
      >
        <span class="title">
          {{ subgroup.display_name }}
          <span class="icon-help"></span>
        </span>
        <template slot="popover">
          <div v-if="ugcBlockedPalette">{{ ugcBlockedPaletteMessage }}</div>
          <div v-else>{{ subgroup.tooltip_text }}</div>
        </template>
      </v-popover>
      <!-- showFeatureTabModal(subgroup) -->
      <span
        v-else
        @click="showSelectedModal()"
        class="title">
        {{ subgroup.display_name }}
        <span v-show="hasModal" class="icon-help"></span>
      </span>
      <span class="subtitle">{{ subgroup.subtitle }}</span>
    </div>
    <v-popover
      v-for="(swatch) in swatchesArray"
      v-show="showSwatch(swatch)"
      :delay="{'show':500}"
      :key="`${subgroup.name}-${swatch.id}${swatch.color ? ('-' + swatch.color) : ''}`"
      :disabled="!!ugcBlockedPalette || Number(swatch.id) == 10900"
      popoverClass="swatches-view-v-popover"
      class="swatches-view-swatches-wrapper-swatches-container"
      placement="top"
      trigger="hover click"
      :ref="`pop-swatch-${swatch.id}`"
    >
      <button
      :aria-hidden="showSwatch(swatch) ? false : true"
      :aria-pressed="showCheckedIcon(swatch) ? 'true' : 'false'"
      :aria-label="returnSwatchName(swatch.display_name)"
        :class="[
          'swatch',
          subgroup.name,
          swatch.check_icon_color,
          { 'disabled': blockedSwatches[swatch.id] || !!ugcBlockedPalette }
        ]"
        :data-swatch-id="swatch.id"
        :key="swatch.id + (swatch.color || '')"
        :data-swatch-name="returnSwatchName(swatch.display_name)"
        :data-swatch-group="swatch.ugc_swatch_group"
        :data-subgroup="subgroup.name"
        :data-group="groupName"
        :data-color="swatch.color"
        :ref="`swatch-${swatch.id}`"
        :style="`width: ${widthSwatch}`"
        @click="selectSwatch(swatch)"
        @mouseover="setSwatchMessage(swatch)"
        @focus="onSwatchFocus(swatch)"
        @blur="onSwatchBlur(swatch)"
        @keydown.esc="onSwatchEsc(swatch)"
      >
        <div :class="`background ${zoomLevelHigh ? 'zoom-level-high' : ''}`" :style="swatchBackgroundStyle(swatch)">
          <div
            v-if="ugcBlockedPalette"
            class="swatches-view-swatches-wrapper-swatches-container-ugc-lock"
          >
            <img alt="customs-header-icon" aria-hidden="true"
              :src="`${ $store.state.endPoints.customizer.customsAssets }/svg/customizer/icon-lock.svg`"
              class="customs-header-icon"
            />
          </div>
          <span
            v-else
            v-show="showCheckedIcon(swatch)"
            class="icon-check-swatch"
          ></span>
          <button
            v-if="shouldShowRemoveIcon(swatch)"
            class="button-remove-swatch"
            @click.stop="removePyocSwatch(swatch)"
          >
            <span class="button-remove-swatch__background"></span>
            <span class="button-remove-swatch__icon">
              <!-- × symbol in the close icon -->
              &#215;
            </span>
          </button>
        </div>
      </button>
      <template slot="popover">
        <div v-html="swatchMessage" >
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
import selectSwatch from '@/mixins/Customizer/SelectSwatch';
import ugc from '@/mixins/UGC';

export default {
  name: "Swatches",
  mixins: [
    selectSwatch,
    ugc
  ],
  data() {
    return {
      swatchMessage: ""
    }
  },
  props: {
    swatchesArray: {
      type: Array,
      default: function() {
        return [];
      },
      required: true
    },
    subgroup: {
      type: Object,
      default: function() {
        return {};
      },
      required: true
    },
    groupName: {
      type: String,
      default: "",
      required: true
    },
    hasModal: {
      type: Boolean,
      default: false,
      required: true
    },
    isFirstSubgroup: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    upgradeOptionsStore(){
      return this.$store.state.geometryUpdates.upgradeOptions;
    },
    translations() {
      return this.$store.state.translations.data;
    },
    containerSize() {
      return this.$store.state.swatches.tabContainerSize;
    },
    widthSwatch() {
      let containerSize = this.containerSize;
      const groupData = this.$store.state.swatches.groupTabs[this.groupName];
      if(containerSize < 1024) return "";
      if (this.hasNoSubgroups && !groupData.title_only && containerSize > 600 && this.getTotalSwatchesSolids) {
        return containerSize / this.getTotalSwatchesSolids + "px";
      }
      return "";
    },
    getTotalSwatchesSolids() {
      return this.$store.state.swatches.tabsSwatches[this.activeComponent]?.["solids"]?.total ?? 0;
    },
    ugcBlockedPaletteMessage() {
      return (this.activeComponent && this.translations[`ugcLockPalettePopover-${ this.activeComponent }`]) || '';
    },
    ugcBlockedPalette() {
      return this.$store.state.ugc.ugcBlockedPalettes[this.activeComponent] || null;
    },
    isSubgroupHidden() {
      let visibleByUgcBlock = true;

      if (this.ugcBlockedPalette) {
        visibleByUgcBlock = parseInt(this.$props.subgroup.palette_id) === this.ugcBlockedPalette;
      }

      return visibleByUgcBlock && this.swatchesArray.length > 0;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    selectedSwatch() {
      return this.$store.state.swatches.selectedSwatches[this.activeComponent];
    },
    previousComponent() {
      return (this.configuration.enableFlyOutMenu || this.isApparelEnabled) ?
        this.$store.state.standardNavigation.lastComponentSwatchApplied :
        this.$store.state.legacyNavigation.lastComponentSwatchApplied;
    },
    previousSwatch() {
      return this.$store.state.swatches.selectedSwatches[this.previousComponent];
    },
    activeSwatch() {
      let swatchActive = this.selectedSwatch || "";
      let swatchDefault = 0;
      if (!this.recipe_v2?.components) return '0'
      if (String(this.activeComponent).search('/') !== -1) {
        const componentName = String(this.activeComponent).split('/');
        swatchDefault =
        this.recipe_v2?.components[componentName[0]]?.sub_components?.[componentName[1]]
        ?
        this.recipe_v2?.components[componentName[0]]?.sub_components?.[componentName[1]]?.swatch_id
        : 0;
      } else {
        swatchDefault = this.recipe_v2?.components[this.activeComponent]
        ?
        this.recipe_v2?.components[this.activeComponent]?.swatch_id
        : 0;
      }

      return String(swatchDefault);
    },
    exclusiveSwatches() {
      return this.$store.state.swatches.exclusiveSwatches[this.activeComponent];
    },
    tabsSwatches() {
      if(!this.$store.state.swatches.tabsSwatches) {
        return null;
      }
      return this.$store.state.swatches.tabsSwatches[this.activeComponent];
    },
    selectedTabPerComponent(){
      return this.$store.state.swatches.selectedTabs[this.activeComponent];
    },
    disabledSwatchesByUGC() {
      return this.$store.state.swatches.disabledSwatchesByFeature.ugc;
    },
    disabledSwatchesByCustomCheckerboard() {
      return this.$store.state.swatches.disabledSwatchesByFeature.customCheckerboard;
    },
    disabledSwatchesByPersonalization() {
      return this.$store.state.swatches.disabledSwatchesByFeature.personalization;
    },
    disabledSwatchesByPattern() {
      return this.$store.state.swatches.disabledSwatchesByFeature.patternMaker;
    },
    isContainerCenter() {
      const blockedAndUniqueDisabled = !this.ugcBlockedPalette && !this.uniqueSwatches.length && !this.blockedPalettes.length;

      return (
        this.getTotalSwatchesSolids
        && this.getTotalSwatchesSolids < 8
        && this.groupName !== 'upgradeoptions'
        && blockedAndUniqueDisabled
        && !this.isMobile
        || (
          this.groupName === 'yourcolors'
          && !this.isMobile
        )
      );
    },
    hasNoSubgroups() {
      const group = 'solids';
      let componentName = this.activeComponent;
      if (String(this.activeComponent).search('/') !== -1) {
        componentName = 'sub_component';
      }
      const swatchData = this.$store.state.swatches.swatchesByComponent &&
        this.$store.state.swatches.swatchesByComponent[componentName] &&
        this.$store.state.swatches.swatchesByComponent[componentName][this.groupName];

      return this.groupName === group &&
        !!swatchData && Object.keys(swatchData).length === 1 &&
        !!swatchData[group] && !!swatchData[group].length;
    },
    productOptionToggle() {
      return this.$store.state.swatches.productOptionToggle;
    },
    swatchesListByComponent() {
      return this.$store.state.swatches.swatchesListByComponent[this.activeComponent] || [];
    },
    activeComponentIsNotUgc() {
      return !this.$recipe.getUGCFeatureType(this.activeComponent);
    },
    blockedSwatches() {
      const obj = {};
      this.swatchesListByComponent.forEach(swatch => obj[swatch] = this.blockSwatches(swatch));
      return obj;
    },
    /*
     * @computed - blockedPalettes
     * Array with palette IDs with palette_lock attribute as 1
     */
    blockedPalettes() {
      return this.$store.getters['swatches/lockedPalettes'].reduce((whole, { id }) => {
        if (id && !whole.includes(id) && id === parseInt(this.$props.subgroup.palette_id)) {
          whole.push(id);
        }
        return whole;
      }, []);
    },
    /*
     * @computed - blockedPalettes
     * Array with unique swatch IDs with unique_swatch attribute as true
     */
    uniqueSwatches() {
      return this.$store.getters['swatches/uniqueSwatches'].reduce((whole, swatch) => {
        if (this.swatchesListByComponent && this.swatchesListByComponent.includes(swatch.id) && !whole.includes(swatch.id)) {
          whole.push(swatch.id);
        }

        return whole;
      }, []);
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
    lastKeyWasTab() {
      return this.$store.state.swatchTray.lastKeyWasTab;
    },
    zoomLevelHigh() {
      return this.$store.state.utils.zoomLevel > 200;
    }
  },
  methods: {
    isUpgradeOptionsActive(swatch){
      return (this.upgradeOptionsStore[swatch.id] && this.upgradeOptionsStore[swatch.id].status);
    },
    swatchBackgroundStyle(swatch) {

      if (swatch.image_assets && swatch.image_assets.ui) {
        return {
          "background-image": `url(${this.$store.getters["utils/addCacheBusting"](this.$store.getters['endPoints/swatchesPath']() + swatch.image_assets.ui)})`
        };
      } else {
        if (swatch.color) {
          return { "background-color": swatch.color };
        }
      }
    },
    returnToggleState(swatch) {
      let state = false;

      if (this.productOptionToggle[swatch.id]) {
        state = this.productOptionToggle[swatch.id].status;
      } else if (this.productOptionToggle[this.activeComponent]) {
        state = this.productOptionToggle[this.activeComponent].status && this.productOptionToggle[this.activeComponent].swatchId === swatch.id;
      }

      return state;
    },
      /**
     * @function getUpchargeDisplay
     * @param {String} groupName - Name of the swatch main group (solids, materials, etc.)
     * @param {String} subGroupName - Name of the swatch subgroup (simpsons, checkerboards, etc.)
     * This method checks if a translation for upcharge exists and return it
     * if it doesn't exist by component it checks then by default and group and subgroup
     */
    getUpchargeDisplay(groupName, subGroupName) {
      if (this.configuration.enableUpchargeFromS3) return this.getUpchargeDisplayFromS3(groupName, subGroupName)
      return this.getUpchargeDisplayFromAEM(groupName, subGroupName)
    },
    getUpchargeDisplayFromAEM(groupName, subGroupName) {
      const componentDisplay = `upchargeDisplay-${this.pdm.sku}-${this.activeComponent}-${groupName}-${subGroupName}`;
      const defaultDisplay = `upchargeDisplay-default-${this.activeComponent}-${groupName}-${subGroupName}`;
      let finalDisplay = '';
      if (this.translations[componentDisplay]) {
        const componentTrim = this.translations[componentDisplay].trim() === "blankSpace" ? "" : this.translations[componentDisplay];
        finalDisplay = !!componentTrim ? `(${ componentTrim })` : componentTrim;
      } else if (this.translations[defaultDisplay]) {
        const defaultTrim = this.translations[defaultDisplay].trim() === "blankSpace" ? "" : this.translations[defaultDisplay];
        finalDisplay = !!defaultTrim ? `(${ defaultTrim })` : defaultTrim;
      }
      return finalDisplay;
    },
    getUpchargeDisplayFromS3(groupName, subGroupName) {
      const sku = this.pdm.sku;
      const activeComponent = this.activeComponent;

      let model;
      try {
        model = this.$store.state.translations.upcharge?.[sku]?.[activeComponent]?.[groupName];
        if(model?.[subGroupName]) {
          return model?.[subGroupName]?.toLowerCase() === "blankspace" ? '' : `(${model?.[subGroupName]})`;
        } else {
           model = this.$store.state.translations.upcharge["default"]?.[activeComponent]?.[groupName];
           if(model?.[subGroupName]) {
             return model?.[subGroupName].toLowerCase() !== "blankspace" ? `(${model?.[subGroupName]})` :'';
           }
        }
      } catch (err) {
        console.error("The upcharge display is not available", err);
      }
      return ""
    },
    // hide opened
    hideOtherPopovers(swatchId) {
      const currentId = `pop-swatch-${swatchId}`
      Object.keys(this.$refs)
        .filter(refName => refName.startsWith("pop"))
        .forEach(refName => {
          const pop = this.$refs[refName][0];
          if (!pop) return;
          if (refName === currentId) return;
          pop.hide();
        });
    },
    setSwatchMessage(swatch){
      this.hideOtherPopovers(swatch.id)
      if (!swatch.display_name) this.swatchMessage = "";
      else if(!this.$refs['swatch-'+ swatch.id]) {
        this.swatchMessage = "<span>"+this.returnSwatchName(swatch.display_name)+"<span>";
      }else{
        if(this.$refs['swatch-'+ swatch.id] && this.$refs['swatch-'+ swatch.id].length > 0) {
          const swatchObj =  this.$refs['swatch-'+ swatch.id][0];
          if(swatchObj.classList.contains("disabled")){
            this.swatchMessage = "<span>"+this.translations.errorSwatchHasExclusiveSwatchBlocked+"</span>";
          } else {
            this.swatchMessage = "<span>"+this.returnSwatchName(swatch.display_name)+"<span>";
          }
        }
      }
    },
    /**
     * @function showSelectedModal
     * Shows either the palette or Feature Tab modal based on config settings
     * Runs the dataLayer track event
     */
    showSelectedModal() {
      if (!this.hasModal) return;
      if (this.configuration.enableTranslationFeatureTabs) {
        this.$modal.show("featureTabModal", {featureTab: this.translations.featureTabs[this.subgroup.name]});
      } else {
        this.$modal.show("paletteModal", {contentUrl: this.subgroup.modal_url});
      }
      if (!this.$store.getters['utils/noEsiActive']) {
        const dataLayerSource = this.canvasActive ? parent.dataLayer : dataLayer;
        dataLayerSource.push({
          'event':'trackEvent',
          'eventCategory':'customs',
          'eventAction': this.groupName,
          'eventLabel':`learn more ${this.subgroup.display_name}`
        });
      }
    },
    /** Hide swatch for specific rules**/
    showSwatch(swatch) {
      let show = true;
      if (swatch.ugcOnly && !this.$recipe.checkIfDecostitchIsAllowed({ugcOnly: swatch.ugcOnly})) {
        show = false;
      } else if (this.ugcBlockedPalette) { // If exists palette with ugc_locked (by recipe ugc_lock), only the active swatch is visible (and locked)
        show = swatch.id === this.activeSwatch;
      } else if (this.uniqueSwatches.length) { // If exist unique swatches (by swatch unique_swatch), only they are visible
        show = this.uniqueSwatches.includes(swatch.id);
      } else if (this.blockedPalettes.length) { // If exist locked palettes (by palette palette_lock), only their own swatches are visible
        const paletteId = this.$store.getters['swatches/getPaletteDataBySwatch'](swatch.id, 'id');
        show = this.blockedPalettes.includes(parseInt(paletteId));
      }
      return show;
    },
    blockSwatches(swatchId) {
      if (!swatchId) {
        return false;
      }

      const swatchID = Number(swatchId);
      if(this.isComponentExclusive()) {
        return false;
      }
      if(this.exclusiveSwatches instanceof Array && this.exclusiveSwatches.includes(swatchID)) {
        return true;
      }
      if (this.disabledSwatchesByPersonalization instanceof Array && this.disabledSwatchesByPersonalization.includes(swatchID)) {
        return true;
      }

      const checkerboardChecks = this.$store.getters['ugc/getComponentsByUGCSubgroupApplied']({ subgroupIdentifier: "custom-checkerboard"});
      this.disabledSwatchesbyUGCFeature({components: checkerboardChecks, disabledSwatchesbyUGCSubgroup: this.disabledSwatchesByCustomCheckerboard, swatchID});

      const ugcChecks = this.$store.getters['ugc/getComponentsWithUGCApplied'];
      this.disabledSwatchesbyUGCFeature({components: ugcChecks, disabledSwatchesbyUGCSubgroup: this.disabledSwatchesByUGC, swatchID});

      const patternChecks = this.$store.getters['ugc/getComponentsByUGCSubgroupApplied']({ subgroupIdentifier: "checkerboard-creator"});
      this.disabledSwatchesbyUGCFeature({components: patternChecks, disabledSwatchesbyUGCSubgroup: this.disabledSwatchesByPattern, swatchID});

      return false;
    },
    disabledSwatchesbyUGCFeature({components, disabledSwatchesbyUGCSubgroup, swatchID}){
      if (components.length && (disabledSwatchesbyUGCSubgroup instanceof Array && disabledSwatchesbyUGCSubgroup.includes(swatchID))) {
        const ugcEnabledComponents = this.$store.getters['ugc/getUGCEnabledComponents'];

        if ((ugcEnabledComponents.length > 0) &&  // If components with pattern allowed are at least 1
          ((components.length === 1 && components[0] !== this.activeComponent) ||  // Only 1 component has pattern and is not the active one
            components.length > 1)) { // More than 1 components has pattern active
            return true;
        }
      }
    },
    setUgcSwatchXPosition() {
        const ugcPreviousSwatchGroup = this.$store.state.swatches.selectedSwatches[this.previousComponent].ugcswatchgroup;
        if (!ugcPreviousSwatchGroup) return;
        const swatch = `[data-swatch-group="${ ugcPreviousSwatchGroup }"]`;
        const swatchContainer = document.getElementsByClassName("swatchesContainerActive");
        const selectedSwatchDOMElement = swatchContainer[0].querySelector(swatch);
        if (selectedSwatchDOMElement && selectedSwatchDOMElement.offsetLeft) {
          this.$eventBus.$emit("changeSwatchesScrollPosition", selectedSwatchDOMElement.offsetLeft);
        }
        else return;
    },
    getSelectedSwatchXPosition(tabNameSelectedSwatch) {
      this.$nextTick(() => {
        if (this.groupName !== tabNameSelectedSwatch) {
          return;
        }

        if (this.selectedSwatch && this.selectedSwatch.swatchId && !this.selectedSwatch.default) {
          const selectedSwatchDOMElement = this.$refs[`swatch-${ this.selectedSwatch.swatchId }`];

          if (selectedSwatchDOMElement && selectedSwatchDOMElement[0] && selectedSwatchDOMElement[0].offsetParent !== null) {
            this.$eventBus.$emit("changeSwatchesScrollPosition", selectedSwatchDOMElement[0].offsetLeft);
          }
        } else if (this.configuration.enableAutoSelect && this.previousSwatch &&
          this.previousSwatch.swatchId && !this.previousSwatch.default) {
          const selectedSwatchDOMElement = this.$refs[`swatch-${ this.previousSwatch.swatchId }`];

          if (selectedSwatchDOMElement && selectedSwatchDOMElement[0] && selectedSwatchDOMElement[0].offsetParent !== null) {
            this.$eventBus.$emit("changeSwatchesScrollPosition", selectedSwatchDOMElement[0].offsetLeft);
          } else {
            this.setUgcSwatchXPosition();
          }
        }
      });
    },
    showCheckedIcon(swatch){
      if (this.isApparelEnabled
        && !this.activeComponent.search('/')
        && !this.recipe_v2.components[this.activeComponent]) return false;
      return (
        (
          this.activeSwatch === swatch.id
          && this.activeComponentIsNotUgc
          // if the swatch has the 'hex' attribute, it must match the color (required by PYOC feature)
          && (
            !this.selectedSwatch?.hex
            || this.selectedSwatch?.hex === swatch.color
          )
        )
        || this.returnToggleState(swatch)
        || this.isUpgradeOptionsActive(swatch)
      )
    },
    shouldShowRemoveIcon(swatch) {
      return swatch.subgroup === "standard-ugc-solids" && this.$store.state.pickYourOwnColor.isRemoving;
    },
    removePyocSwatch(swatch) {
      this.$store.commit("pickYourOwnColor/REMOVE_SWATCH", swatch);
      this.$store.dispatch("pickYourOwnColor/SAVE_COLORS", this.$store.state.pickYourOwnColor.swatches.map(color => color.color));
    },
    // Fix for accesibility
    checkTabPressedOnce() {
      // Reset lastKeyWasTab
      const v = this.lastKeyWasTab;
      this.$store.commit(
        'swatchTray/SET_LAST_KEY_WAS_TAB',
        false
      ); 
      return v;
    },
    onSwatchFocus(swatch) {
      if (this.checkTabPressedOnce()) {
        this.setSwatchMessage(swatch);
        this.$refs[`pop-swatch-${swatch.id}`][0].show();
      }
    },
    onSwatchBlur(swatch) {
      this.$refs[`pop-swatch-${swatch.id}`][0].hide()
    },
    onSwatchEsc(swatch) {
      this.$refs[`pop-swatch-${swatch.id}`][0].hide()
    }
  },
  mounted() {
    if (!window.__tabListenerRegistered) {
      window.addEventListener('keyup', e => {
        this.$store.commit(
          'swatchTray/SET_LAST_KEY_WAS_TAB',
          e.key === 'Tab'
        );
      }, true);
      window.__tabListenerRegistered = true;
    }
  },
  created() {
    this.$eventBus.$on('changeVisibleGroup', this.getSelectedSwatchXPosition);
  },
  beforeDestroy() {
    this.$eventBus.$off('changeVisibleGroup', this.getSelectedSwatchXPosition);
  }
};
</script>
